import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import * as routes from '../routes'
import { Login } from '../auth'
import authClient from '../auth/authClient'
import { Loading } from '../shared'

const ProducerLogin = (props) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    authClient.initialize(() => {
      const handler = () => { setLoading(false) }
      authClient.tryLogin(routes.producerSignInUrl).then(handler).catch(handler)
    })
  }, [])

  if (loading) {
    return <Loading />
  }
  if (authClient.isLoggedIn()) {
    return <Navigate to={routes.producerBeatsPath} />
  }

  const loginProps = {
    providers: ['google', 'facebook', 'apple', 'beatstars', 'phone'],
    signInUrl: routes.producerSignInUrl,
    signUpPath: routes.producerSignUpPath,
    afterLoginPath: routes.producerBeatsPath
  }
  return <Login {...loginProps} {...props} />
}

export default ProducerLogin
